import { useEffect } from "react";
import { config } from "runtimeConfig";

const SSO_BASE_URL = config.SSO_BASE_URL;
const SSOLoginPage = () => {
  useEffect(() => {
    if (SSO_BASE_URL) {
      window.location.href = decodeURIComponent(SSO_BASE_URL);
    }
  }, [])

  return null;
}

export default SSOLoginPage;